import { useNavigate } from 'react-router-dom';
import {
  ArrowDownCircle,
  ArrowUpCircle,
  Calculator,
  Sliders,
  FileText,
  Lock
} from 'lucide-react';

import { useCashSession } from '../../hooks/cash/useCashSession';

const CashActionsCard = () => {
  const navigate = useNavigate();
  const { activeSession } = useCashSession();

  const actions = [
    {
      label: 'Ingreso',
      icon: ArrowDownCircle,
      color: 'bg-[#3CA745]',
      text: 'text-white',
      path: '/cash/income',
    },
    {
      label: 'Retiro',
      icon: ArrowUpCircle,
      color: 'bg-[#DC3545]',
      text: 'text-white',
      path: '/cash/withdrawal',
    },
    {
      label: 'Ajuste',
      icon: Sliders,
      color: 'bg-[#3BA2B8]',
      text: 'text-white',
      path: '/cash/adjustment',
    },
    {
      label: 'Arqueo',
      icon: Calculator,
      color: 'bg-[#F9C107]',
      text: 'text-black',
      path: '/cash/audit',
    },
    {
      label: 'Corte X',
      icon: FileText,
      color: 'bg-[#637381]',
      text: 'text-white',
      path: '/cash/summary-x',
    },
    {
      label: 'Cerrar caja',
      icon: Lock,
      color: 'bg-[#212B36]',
      text: 'text-white',
      path: '/cash/summary-z',
    },
  ];

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      {/* HEADER */}
      <div className="flex items-center justify-between border-b border-stroke px-6 py-4 dark:border-strokedark">
        <h3 className="font-medium text-black dark:text-white">
          Acciones de Caja
        </h3>

        {/* STATUS */}
        <span
          className={`
          inline-flex rounded px-2 py-0.5 text-xs font-medium
          ${
            activeSession
              ? 'bg-[#3CA745] text-white'
              : 'bg-[#DC3545] text-white'
          }
        `}
        >
          {activeSession ? 'Caja abierta' : 'Sin sesión'}
        </span>
      </div>

      {/* BODY */}
      <div className="grid grid-cols-2 gap-4 p-6">
        {actions.map((action) => {
          const Icon = action.icon;

          return (
            <button
              key={action.label}
              onClick={() => navigate(action.path)}
              disabled={!activeSession}
              className={`
                flex flex-col items-center justify-center gap-2
                rounded-md px-4 py-4 text-sm font-medium
                transition hover:scale-[1.03] hover:brightness-110
                disabled:cursor-not-allowed disabled:opacity-40
                ${action.color} ${action.text}
              `}
            >
              <Icon size={20} />
              {action.label}
            </button>
          );
        })}
      </div>

      {/* FOOTER INFO */}
      {!activeSession && (
        <div className="border-t border-stroke px-6 py-3 text-xs text-[#3BA2B8] dark:border-strokedark">
          Debes abrir una caja para habilitar las operaciones.
        </div>
      )}
    </div>
  );
};

export default CashActionsCard;
